
import React, { lazy, Suspense } from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import FlowMenu from '@navigation/screens/MidLevel/DataScreen/ActionHandler/FlowDesigner/FlowMenu';
import CallFlows from '@navigation/screens/MidLevel/DataScreen/ActionHandler/FlowDesigner/CallFlows';
import FlowDesigner from '@navigation/screens/MidLevel/DataScreen/ActionHandler/FlowDesigner/Screens/FlowHandlerScreen';
import { FlowStackParamList } from '@navigation/types';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';

// Import FlowEditor directly (not lazy) to ensure it's registered
// Temporarily using simple version to test navigation
// const FlowEditor = require('@navigation/screens/MidLevel/DataScreen/ActionHandler/FlowDesigner/FlowEditor').default;


const FlowStack = createStackNavigator<FlowStackParamList>();

const FlowNavigator = () => {
  const theme = themeSelector();


  return (
    <FlowStack.Navigator
      screenOptions={{
        headerShown: false
      }}
      initialRouteName='FlowMenu'
    >
      <FlowStack.Screen
        name='FlowMenu'
        component={FlowMenu}
        options={{ title: 'Flow Menu' }}
      />
      <FlowStack.Screen
        name="ManualFlows"
        component={FlowDesigner}
        options={{ title: 'Manual Flows' }}
      />
      <FlowStack.Screen
        name="SalesFlows"
        component={FlowMenu}
        options={{ title: 'Sales Flows' }}
      />
      <FlowStack.Screen
        name="CallFlows"
        component={CallFlows}
        options={{ title: 'Call Flows' }}
      />
      <FlowStack.Screen
        name="FlowDesigner"
        component={FlowDesigner}
        options={{ title: 'Flow Designer' }}
      />
    </FlowStack.Navigator>
  )
}
export { FlowNavigator, FlowStack };